import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid, Checkbox } from '@material-ui/core'
import { useGetAiModels } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import OpalPresentationTable from '../../../../../components/organisms/DenaliAnalysis/tables/presentation'

const columns = [
  { accessorKey: 'providerName', header: 'Provider', id: 'providerName' },
  { accessorKey: 'modelName', header: 'Model', id: 'modelName' },
  { accessorKey: 'tasks', header: 'Tasks', id: 'tasks' },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    id: 'enabled',
    cell: (info) => {
      const enabled = info.getValue()
      return (
        <Checkbox
          checked={Boolean(enabled)}
          disabled
          size='small'
          readOnly
        />
      )
    }
  }
]

function ModelsList () {
  const { data, isLoading } = useGetAiModels()

  const tableData = useMemo(() => {
    return (data?.models || []).map(rt => ({
      providerName: rt.provider?.name || 'Unknown',
      modelName: rt.name,
      tasks: rt.tasks?.length || '0',
      enabled: rt.enabled
    }))
  }, [data])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <OpalPresentationTable
          columns={columns}
          data={tableData}
          defaultSort={[]}
        />
      </Grid>
    </Grid>
  )
}

ModelsList.propTypes = {
  datasource: PropTypes.shape({
    models: PropTypes.array
  })
}

export default ModelsList
